import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, GetDataGridItemsResponse } from '../types';
import {
  ColumnDetails,
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
  SetFiltersRequest,
} from '../../../grid/types/common';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { getRequestDefaultOptions } from '../../../utils/request.utils';

export class XdrSearchResultsPanelGzDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  response: any;
  limit = 50;

  constructor(public dependencies: any, private allColumnDetails: Array<ColumnDetails<Column, ColumnKeys>>) {
    super();
  }

  async getEdrStandardEvents(request: any): Promise<any> {
    request.pageSize = this.limit;
    const response = await this.dependencies.api.clients.EdrStandardEvents.readRecords(
      request,
      getRequestDefaultOptions()
    );

    this.response = response;

    return response;
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    if (
      !request.extraParams.companyId ||
      !request.extraParams.startDate ||
      !request.extraParams.endDate ||
      !request.extraParams.query
    ) {
      return sanitizeObject({
        summary: `0 items`,
        numItems: 0,
      });
    }

    request.pageSize = this.limit;
    let response = this.response;
    if (!response) {
      response = await this.dependencies.api.clients.EdrStandardEvents.readRecords(request, getRequestDefaultOptions());

      this.response = response;
    }

    return sanitizeObject({
      summary: `${response.total} items`,
      numItems: response.total,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetDataGridItemsResponse> {
    if (
      !request.extraParams.companyId ||
      !request.extraParams.startDate ||
      !request.extraParams.endDate ||
      !request.extraParams.query
    ) {
      return sanitizeObject({ rawEvents: [] });
    }

    let response = this.response;
    request.pageSize = this.limit;
    if (!response) {
      response = await this.dependencies.api.clients.EdrStandardEvents.readRecords(request, getRequestDefaultOptions());
    } else {
      this.response = null;
    }

    return sanitizeObject({ rawEvents: response.data });
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    this.limit = request.pageSize ?? 50;
    return {};
  }
}
